import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
    EntityValidations, ISpecificEntityFormProps, IApp03WorkflowStage, App03WorkflowStage,
    ICLDefApprover,
    CLDefApprover
} from '../../types';
import { LookupService } from '../../services';
import styles from '../../styles/cr.module.scss';
import { CrTextField } from '../cr/CrTextField';
import { CrDropdown } from '../cr/CrDropdown';
import { EntityForm } from '../EntityForm';
import { DataContext } from '../DataContext';
import { CrChoiceGroup } from '../cr/CrChoiceGroup';
import { CrCheckbox } from '../cr/CrCheckbox';
import useMobileDetector from '../useMobileDetector';
import { ICommandBarItemProps, IDropdownOption } from '@fluentui/react';
import { OrbUserContext } from '../OrbUserContext';
import { EntityFormPage } from '../EntityFormPage';

interface ICLDefApproversProps extends ISpecificEntityFormProps {
    // requestStage: IApp03WorkflowStage;
    // workflowID: number;
}


class CLDefApproverFormValidations extends EntityValidations {
    public AssignedTo: string = null;
}

export const CLDefApprovers = (props: ICLDefApproversProps): React.ReactElement => {
    const isMobile = useMobileDetector();

    const { dataServices, lookupData, loadLookupData: { cLComFrameworks, } } = useContext(DataContext);
    useMemo(() => cLComFrameworks(), [cLComFrameworks]);

    const yesNoNaOptions: IDropdownOption[] = [
        { key: 'Yes', text: 'Yes' },
        { key: 'No', text: 'No' },
    ];

    const frameworkCriteriaOptions: IDropdownOption[] = [
        { key: 'All', text: 'All frameworks' },
        { key: 'ThisFramework', text: 'Only selected framework' },
        { key: 'NotThisFramework', text: 'All except selected framework' },
    ];

    //const clComFrameworksAll = [{ ID: 0, Title: 'All' }, ...lookupData.CLComFrameworks];
    const clComFrameworksAll = lookupData.CLComFrameworks;


    useEffect(() => {

    }, [props.entityId]);


    const validateEntity = (defApprovers: ICLDefApprover): Promise<CLDefApproverFormValidations> => {
        const errors = new CLDefApproverFormValidations();


        return Promise.resolve(errors);
    };



    return (
        <>
            <EntityFormPage<ICLDefApprover, CLDefApproverFormValidations>
                {...props}
                entityName='DefApprover'
                renderFormFields={(changeHandlers, formState) => {
                    const { FormData: formData, ValidationErrors: errors } = formState;


                    // const commandBarItems: ICommandBarItemProps[] = [
                    //     {
                    //         key: 'Close',
                    //         text: 'Close',
                    //         iconProps: { iconName: 'Cancel' },
                    //         onClick: (ev, item) => {
                    //             props.onCancelled();
                    //         },
                    //     },
                    // ].filter(Boolean);

                    //Labels row 3



                    return (
                        <>
                            <div style={{ marginTop: '30px', backgroundColor: 'rgb(240,240,240)', padding: '10px' }}>

                                {isMobile !== true &&
                                    <div className="form-container">
                                        <div className="form-item-25">
                                            <span>Approver 1 Title</span>
                                        </div>
                                        <div className="form-item-25">
                                            <span>Applies To</span>
                                        </div>
                                        {formData.Approver1FrameworkCriteria !== 'All' && <div className="form-item-25">
                                            <span>Framework</span>
                                        </div>}
                                        <div className="form-item-25-last">
                                            <span>Allow Set Approver</span>
                                        </div>
                                    </div>

                                }
                                <div className="form-row">
                                    {isMobile && <div className="form-item">
                                        <span>Approver 1 Title</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrTextField
                                            value={formData.Approver1}
                                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Approver1')}
                                        />
                                    </div>

                                    {isMobile && <div className="form-item">
                                        <span>Applies To</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrDropdown
                                            options={frameworkCriteriaOptions}
                                            selectedKey={formData.Approver1FrameworkCriteria}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver1FrameworkCriteria', null, (da) => {
                                                console.log('after selecting criteria', da.Approver1FrameworkCriteria);
                                            })}
                                        />
                                    </div>

                                    {isMobile && formData.Approver1FrameworkCriteria !== 'All' && <div className="form-item">
                                        <span>Framework</span>
                                    </div>}
                                    {formData.Approver1FrameworkCriteria !== 'All' && <div className="form-field-25">
                                        <CrDropdown
                                            options={LookupService.entitiesToSelectableOptions(clComFrameworksAll)}
                                            selectedKey={formData.Approver1FrameworkID}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver1FrameworkID')}
                                        />
                                    </div>}

                                    {isMobile && <div className="form-item-last">
                                        <span>Allow Set Approver</span>
                                    </div>}
                                    <div className="form-field-25-last">
                                        <CrDropdown
                                            options={yesNoNaOptions}
                                            selectedKey={formData.Approver1UserRequired}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver1UserRequired')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '30px', backgroundColor: 'rgb(240,240,240)', padding: '10px' }}>

                                {isMobile !== true &&
                                    <div className="form-container">
                                        <div className="form-item-25">
                                            <span>Approver 2 Title</span>
                                        </div>
                                        <div className="form-item-25">
                                            <span>Applies To</span>
                                        </div>
                                        {formData.Approver2FrameworkCriteria !== 'All' && <div className="form-item-25">
                                            <span>Framework</span>
                                        </div>}
                                        <div className="form-item-25-last">
                                            <span>Allow Set Approver</span>
                                        </div>
                                    </div>

                                }
                                <div className="form-row">
                                    {isMobile && <div className="form-item">
                                        <span>Approver 2 Title</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrTextField
                                            value={formData.Approver2}
                                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Approver2')}
                                        />
                                    </div>

                                    {isMobile && <div className="form-item">
                                        <span>Applies To</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrDropdown
                                            options={frameworkCriteriaOptions}
                                            selectedKey={formData.Approver2FrameworkCriteria}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver2FrameworkCriteria')}
                                        />
                                    </div>

                                    {isMobile && formData.Approver2FrameworkCriteria !== 'All' && <div className="form-item">
                                        <span>Framework</span>
                                    </div>}
                                    {formData.Approver2FrameworkCriteria !== 'All' && <div className="form-field-25">
                                        <CrDropdown
                                            options={LookupService.entitiesToSelectableOptions(clComFrameworksAll)}
                                            selectedKey={formData.Approver2FrameworkID}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver2FrameworkID')}
                                        />
                                    </div>}

                                    {isMobile && <div className="form-item-last">
                                        <span>Allow Set Approver</span>
                                    </div>}
                                    <div className="form-field-25-last">
                                        <CrDropdown
                                            options={yesNoNaOptions}
                                            selectedKey={formData.Approver2UserRequired}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver2UserRequired')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '30px', backgroundColor: 'rgb(240,240,240)', padding: '10px' }}>

                                {isMobile !== true &&
                                    <div className="form-container">
                                        <div className="form-item-25">
                                            <span>Approver 3 Title</span>
                                        </div>
                                        <div className="form-item-25">
                                            <span>Applies To</span>
                                        </div>
                                        {formData.Approver3FrameworkCriteria !== 'All' && <div className="form-item-25">
                                            <span>Framework</span>
                                        </div>}
                                        <div className="form-item-25-last">
                                            <span>Allow Set Approver</span>
                                        </div>
                                    </div>

                                }
                                <div className="form-row">
                                    {isMobile && <div className="form-item">
                                        <span>Approver 3 Title</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrTextField
                                            value={formData.Approver3}
                                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Approver3')}
                                        />
                                    </div>

                                    {isMobile && <div className="form-item">
                                        <span>Applies To</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrDropdown
                                            options={frameworkCriteriaOptions}
                                            selectedKey={formData.Approver3FrameworkCriteria}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver3FrameworkCriteria')}
                                        />
                                    </div>

                                    {isMobile && formData.Approver3FrameworkCriteria !== 'All' && <div className="form-item">
                                        <span>Framework</span>
                                    </div>}
                                    {formData.Approver3FrameworkCriteria !== 'All' && <div className="form-field-25">
                                        <CrDropdown
                                            options={LookupService.entitiesToSelectableOptions(clComFrameworksAll)}
                                            selectedKey={formData.Approver3FrameworkID}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver3FrameworkID')}
                                        />
                                    </div>}

                                    {isMobile && <div className="form-item-last">
                                        <span>Allow Set Approver</span>
                                    </div>}
                                    <div className="form-field-25-last">
                                        <CrDropdown
                                            options={yesNoNaOptions}
                                            selectedKey={formData.Approver3UserRequired}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver3UserRequired')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '30px', backgroundColor: 'rgb(240,240,240)', padding: '10px' }}>

                                {isMobile !== true &&
                                    <div className="form-container">
                                        <div className="form-item-25">
                                            <span>Approver 4 Title</span>
                                        </div>
                                        <div className="form-item-25">
                                            <span>Applies To</span>
                                        </div>
                                        {formData.Approver4FrameworkCriteria !== 'All' && <div className="form-item-25">
                                            <span>Framework</span>
                                        </div>}
                                        <div className="form-item-25-last">
                                            <span>Allow Set Approver</span>
                                        </div>
                                    </div>

                                }
                                <div className="form-row">
                                    {isMobile && <div className="form-item">
                                        <span>Approver 4 Title</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrTextField
                                            value={formData.Approver4}
                                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Approver4')}
                                        />
                                    </div>

                                    {isMobile && <div className="form-item">
                                        <span>Applies To</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrDropdown
                                            options={frameworkCriteriaOptions}
                                            selectedKey={formData.Approver4FrameworkCriteria}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver4FrameworkCriteria')}
                                        />
                                    </div>

                                    {isMobile && formData.Approver4FrameworkCriteria !== 'All' && <div className="form-item">
                                        <span>Framework</span>
                                    </div>}
                                    {formData.Approver4FrameworkCriteria !== 'All' && <div className="form-field-25">
                                        <CrDropdown
                                            options={LookupService.entitiesToSelectableOptions(clComFrameworksAll)}
                                            selectedKey={formData.Approver4FrameworkID}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver4FrameworkID')}
                                        />
                                    </div>}

                                    {isMobile && <div className="form-item-last">
                                        <span>Allow Set Approver</span>
                                    </div>}
                                    <div className="form-field-25-last">
                                        <CrDropdown
                                            options={yesNoNaOptions}
                                            selectedKey={formData.Approver4UserRequired}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver4UserRequired')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '30px', backgroundColor: 'rgb(240,240,240)', padding: '10px' }}>

                                {isMobile !== true &&
                                    <div className="form-container">
                                        <div className="form-item-25">
                                            <span>Approver 5 Title</span>
                                        </div>
                                        <div className="form-item-25">
                                            <span>Applies To</span>
                                        </div>
                                        {formData.Approver5FrameworkCriteria !== 'All' && <div className="form-item-25">
                                            <span>Framework</span>
                                        </div>}
                                        <div className="form-item-25-last">
                                            <span>Allow Set Approver</span>
                                        </div>
                                    </div>

                                }
                                <div className="form-row">
                                    {isMobile && <div className="form-item">
                                        <span>Approver 5 Title</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrTextField
                                            value={formData.Approver5}
                                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Approver5')}
                                        />
                                    </div>

                                    {isMobile && <div className="form-item">
                                        <span>Applies To</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrDropdown
                                            options={frameworkCriteriaOptions}
                                            selectedKey={formData.Approver5FrameworkCriteria}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver5FrameworkCriteria')}
                                        />
                                    </div>

                                    {isMobile && formData.Approver5FrameworkCriteria !== 'All' && <div className="form-item">
                                        <span>Framework</span>
                                    </div>}
                                    {formData.Approver5FrameworkCriteria !== 'All' && <div className="form-field-25">
                                        <CrDropdown
                                            options={LookupService.entitiesToSelectableOptions(clComFrameworksAll)}
                                            selectedKey={formData.Approver5FrameworkID}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver5FrameworkID')}
                                        />
                                    </div>}

                                    {isMobile && <div className="form-item-last">
                                        <span>Allow Set Approver</span>
                                    </div>}
                                    <div className="form-field-25-last">
                                        <CrDropdown
                                            options={yesNoNaOptions}
                                            selectedKey={formData.Approver5UserRequired}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver5UserRequired')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '30px', backgroundColor: 'rgb(240,240,240)', padding: '10px' }}>

                                {isMobile !== true &&
                                    <div className="form-container">
                                        <div className="form-item-25">
                                            <span>Approver 6 Title</span>
                                        </div>
                                        <div className="form-item-25">
                                            <span>Applies To</span>
                                        </div>
                                        {formData.Approver6FrameworkCriteria !== 'All' && <div className="form-item-25">
                                            <span>Framework</span>
                                        </div>}
                                        <div className="form-item-25-last">
                                            <span>Allow Set Approver</span>
                                        </div>
                                    </div>

                                }
                                <div className="form-row">
                                    {isMobile && <div className="form-item">
                                        <span>Approver 6 Title</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrTextField
                                            value={formData.Approver6}
                                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Approver6')}
                                        />
                                    </div>

                                    {isMobile && <div className="form-item">
                                        <span>Applies To</span>
                                    </div>}
                                    <div className="form-field-25">
                                        <CrDropdown
                                            options={frameworkCriteriaOptions}
                                            selectedKey={formData.Approver6FrameworkCriteria}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver6FrameworkCriteria')}
                                        />
                                    </div>

                                    {isMobile && formData.Approver6FrameworkCriteria !== 'All' && <div className="form-item">
                                        <span>Framework</span>
                                    </div>}
                                    {formData.Approver6FrameworkCriteria !== 'All' && <div className="form-field-25">
                                        <CrDropdown
                                            options={LookupService.entitiesToSelectableOptions(clComFrameworksAll)}
                                            selectedKey={formData.Approver6FrameworkID}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver6FrameworkID')}
                                        />
                                    </div>}

                                    {isMobile && <div className="form-item-last">
                                        <span>Allow Set Approver</span>
                                    </div>}
                                    <div className="form-field-25-last">
                                        <CrDropdown
                                            options={yesNoNaOptions}
                                            selectedKey={formData.Approver6UserRequired}
                                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'Approver6UserRequired')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    );
                }}
                loadEntity={id => dataServices.cLDefApproverService.read(id, true, true)}
                onAfterLoad={(d) => {
                    //setShowArchived(task.Archived === true ? false : true);
                }}
                loadNewEntity={() => new CLDefApprover()}
                loadEntityValidations={() => new CLDefApproverFormValidations()}
                onValidateEntity={validateEntity}
                onCreate={d => dataServices.cLDefApproverService.create(d)}
                onUpdate={d => dataServices.cLDefApproverService.update(d.ID, d)}
                parentEntities={dataServices.cLDefApproverService.parentEntities}
            // childEntities={[
            //     {
            //         ObjectParentProperty: 'App03TaskUsers',
            //         ParentIdProperty: 'TaskID',
            //         ChildIdProperty: 'UserID',
            //         ChildService: dataServices.app03TaskUserService
            //     },
            // ]}

            //onAfterCreate={t => dataServices.emailNotificationsService.sendEmailOnNewWorkflowTask(t.ID)}
            //onAfterUpdate2={t => dataServices.emailNotificationsService.sendEmailOnEditWorkflowTask(t.ID)}

            />


        </>
    );
};